import { captureMessage } from '@sentry/nextjs';
import { GraphQLError } from '../utils/errors';
import { defaultUrl, GraphQLRequestProps } from '../utils/graphql-request';

const getGraphqlRequestName = (document: GraphQLRequestProps['document']) => {
  return /^.*(?:query|mutation) ([a-zA-Z]+)[( {].*$/m.exec(document.toString())?.[1];
};
export const requestServer = async <Data = any>(
  props: Omit<GraphQLRequestProps, 'locale' | 'idToken'>,
  { tags = [], revalidate }: NextFetchRequestConfig = {},
) => {
  const documentName = getGraphqlRequestName(props.document);
  console.info(`Performing GraphQL request ${documentName}`, props.variables, {
    tags,
    revalidate,
  });
  const response = await fetch(defaultUrl as string, {
    method: 'POST',
    body: JSON.stringify({ query: props.document, variables: props.variables }),
    headers: { ...((props.requestHeaders ?? {}) as any), 'Content-Type': 'application/json' },
    next: {
      revalidate,
      tags: [...tags, `${documentName}-${JSON.stringify(props.variables)}`],
    },
  });
  const data = await response.json();

  if (data.errors) {
    const contentDoesNotExist = data.errors.some((error: { message: string }) =>
      error?.message.includes('Content does not exist'),
    );

    if (!data.data || contentDoesNotExist) {
      const { message, code } = data?.errors?.[0] ?? {
        message: 'No message provided',
        code: 500,
      };

      throw new GraphQLError(message, code);
    }

    captureMessage('uncaught graphql error', {
      level: 'error',
      extra: {
        document: props.document,
        variables: props.variables,
        errorMessage: data.errors,
      },
    });
  }

  return data.data as Data;
};
